import { chains } from 'chain-registry'
import { setClientOptions } from '@skip-go/client'
import { Network, getNetworkEndpoints } from '@injectivelabs/networks'
import { SKIP_BASE_URL } from '@/app/utils/constants/setup'

export default defineNuxtPlugin(() => {
  setClientOptions({
    apiUrl: SKIP_BASE_URL,

    endpointOptions: {
      getRpcEndpointForChain: async (chainId: string) => {
        switch (chainId) {
          case 'injective-1':
            return getNetworkEndpoints(Network.Mainnet).rpc || ''

          case 'cosmoshub-4':
            return 'https://cosmos-rpc.publicnode.com:443'

          default: {
            const chain = (chains || []).find((c) => c.chainId === chainId)

            return chain?.apis?.rpc?.[0]?.address || ''
          }
        }
      }
    }
  })
})
